
export const CATEGORIES = {
  en: {
    "Market Analysis and Strategy": "Market Analysis and Strategy",
    "Business Model Innovation": "Business Model Innovation",
    "Scaling and Growth": "Scaling and Growth",
    "Financial Management": "Financial Management",
    "Fundraising and Investor Relations": "Fundraising and Investor Relations",
    "M&A and Partnerships": "M&A and Partnerships",
    "Pricing and Revenue Optimization": "Pricing and Revenue Optimization",
    "Customer Acquisition and Retention": "Customer Acquisition and Retention",
    "Sales and Marketing Strategy": "Sales and Marketing Strategy",
    "Operations Management": "Operations Management",
    "Leadership Development": "Leadership Development",
    "Negotiation and Influence": "Negotiation and Influence",
    "Public Speaking and Media Relations": "Public Speaking and Media Relations",
    "Time Management and Productivity": "Time Management and Productivity",
    "Personal Branding": "Personal Branding",
    "Resilience and Overcoming Challenges": "Resilience and Overcoming Challenges",
    "Work-Life Balance": "Work-Life Balance",
    "Stress Management and Well-being": "Stress Management and Well-being",
    "Self-Confidence and Imposter Syndrome": "Self-Confidence and Imposter Syndrome",
    "Mentorship and Sponsorship": "Mentorship and Sponsorship",
    "Technology and Innovation": "Technology and Innovation",
    "E-commerce and Digital Marketing": "E-commerce and Digital Marketing",
    "Social Impact and Sustainability": "Social Impact and Sustainability",
    "Healthcare and Biotech": "Healthcare and Biotech",
    "Financial Services": "Financial Services",
    "Consumer Goods and Retail": "Consumer Goods and Retail",
    "Education and Technology": "Education and Technology",
    "Energy and Cleantech": "Energy and Cleantech",
    "Food and Agriculture": "Food and Agriculture",
    "Fashion and Apparel": "Fashion and Apparel",
    "Legal and Regulatory Framework": "Legal and Regulatory Framework",
    "Intellectual Property Protection": "Intellectual Property Protection",
    "Contract Negotiation": "Contract Negotiation",
    "Risk Management": "Risk Management",
    "DE&I Strategy": "DE&I Strategy",
    "Unconscious Bias": "Unconscious Bias",
    "Diversity in Leadership": "Diversity in Leadership",
    "Supplier Diversity": "Supplier Diversity",
    "Peer Support and Networking": "Peer Support and Networking",
    "Coaching and Consulting": "Coaching and Consulting",
    "Career and Life Transition": "Career and Life Transition",
    "Public Relations": "Public Relations",
    "Other": "Other"
  },
  es: {
    "Market Analysis and Strategy": "Análisis de Mercado y Estrategia",
    "Business Model Innovation": "Innovación en Modelos de Negocio",
    "Scaling and Growth": "Escalabilidad y Crecimiento",
    "Financial Management": "Gestión Financiera",
    "Fundraising and Investor Relations": "Recaudación de Fondos y Relaciones con Inversores",
    "M&A and Partnerships": "Fusiones y Adquisiciones y Asociaciones",
    "Pricing and Revenue Optimization": "Optimización de Precios e Ingresos",
    "Customer Acquisition and Retention": "Adquisición y Retención de Clientes",
    "Sales and Marketing Strategy": "Estrategia de Ventas y Marketing",
    "Operations Management": "Gestión de Operaciones",
    "Leadership Development": "Desarrollo de Liderazgo",
    "Negotiation and Influence": "Negociación e Influencia",
    "Public Speaking and Media Relations": "Oratoria y Relaciones con los Medios",
    "Time Management and Productivity": "Gestión del Tiempo y Productividad",
    "Personal Branding": "Marca Personal",
    "Resilience and Overcoming Challenges": "Resiliencia y Superación de Desafíos",
    "Work-Life Balance": "Equilibrio entre Vida Laboral y Personal",
    "Stress Management and Well-being": "Gestión del Estrés y Bienestar",
    "Self-Confidence and Imposter Syndrome": "Autoconfianza y Síndrome del Impostor",
    "Mentorship and Sponsorship": "Mentoría y Patrocinio",
    "Technology and Innovation": "Tecnología e Innovación",
    "E-commerce and Digital Marketing": "Comercio Electrónico y Marketing Digital",
    "Social Impact and Sustainability": "Impacto Social y Sostenibilidad",
    "Healthcare and Biotech": "Salud y Biotecnología",
    "Financial Services": "Servicios Financieros",
    "Consumer Goods and Retail": "Bienes de Consumo y Retail",
    "Education and Technology": "Educación y Tecnología",
    "Energy and Cleantech": "Energía y Tecnologías Limpias",
    "Food and Agriculture": "Alimentación y Agricultura",
    "Fashion and Apparel": "Moda y Confección",
    "Legal and Regulatory Framework": "Marco Legal y Regulatorio",
    "Intellectual Property Protection": "Protección de la Propiedad Intelectual",
    "Contract Negotiation": "Negociación de Contratos",
    "Risk Management": "Gestión de Riesgos",
    "DE&I Strategy": "Estrategia de Diversidad, Equidad e Inclusión",
    "Unconscious Bias": "Sesgos Inconscientes",
    "Diversity in Leadership": "Diversidad en el Liderazgo",
    "Supplier Diversity": "Diversidad de Proveedores",
    "Peer Support and Networking": "Apoyo entre Pares y Networking",
    "Coaching and Consulting": "Coaching y Consultoría",
    "Public Relations": "Relaciones públicas",
    "Career and Life Transition": "Transición profesional y vital",
    "Other": "Otro"
  }
};

export const INDUSTRIES = {
  en: {
    "Aerospace and Defense": "Aerospace and Defense",
    "Automotive": "Automotive",
    "Banking and Capital Markets": "Banking and Capital Markets",
    "Chemicals": "Chemicals",
    "Consumer Markets": "Consumer Markets",
    "Education": "Education",
    "Energy": "Energy",
    "Engineering and Construction": "Engineering and Construction",
    "Entertainment and Media": "Entertainment and Media",
    "Financial Services": "Financial Services",
    "Healthcare": "Healthcare",
    "Hospitality and Leisure": "Hospitality and Leisure",
    "Industrial Manufacturing": "Industrial Manufacturing",
    "Insurance": "Insurance",
    "Life Sciences": "Life Sciences",
    "Mining and Metals": "Mining and Metals",
    "Oil and Gas": "Oil and Gas",
    "Power and Utilities": "Power and Utilities",
    "Real Estate": "Real Estate",
    "Retail": "Retail",
    "Technology": "Technology",
    "Telecommunications": "Telecommunications",
    "Transportation and Logistics": "Transportation and Logistics",
    "Travel and Tourism": "Travel and Tourism",
    "Other": "Other"
  },
  es: {
    "Aerospace and Defense": "Aeroespacial y Defensa",
    "Automotive": "Automoción",
    "Banking and Capital Markets": "Banca y Mercados de Capitales",
    "Chemicals": "Químicos",
    "Consumer Markets": "Mercados de Consumo",
    "Education": "Educación",
    "Energy": "Energía",
    "Engineering and Construction": "Ingeniería y Construcción",
    "Entertainment and Media": "Entretenimiento y Medios",
    "Financial Services": "Servicios Financieros",
    "Healthcare": "Salud",
    "Hospitality and Leisure": "Hostelería y Ocio",
    "Industrial Manufacturing": "Fabricación Industrial",
    "Insurance": "Seguros",
    "Life Sciences": "Ciencias de la Vida",
    "Mining and Metals": "Minería y Metales",
    "Oil and Gas": "Petróleo y Gas",
    "Power and Utilities": "Energía y Servicios Públicos",
    "Real Estate": "Bienes Raíces",
    "Retail": "Comercio Minorista",
    "Technology": "Tecnología",
    "Telecommunications": "Telecomunicaciones",
    "Transportation and Logistics": "Transporte y Logística",
    "Travel and Tourism": "Viajes y Turismo",
    "Other": "Otro"
  }
};

export const INDUSTRIES_NYC = {
  en: {
    "Arts & Culture": "Arts & Culture",
    "Academia (higher ed, postgraduate, academic research)": "Academia (higher ed, postgraduate, academic research)",
    "Banking or Financial Services (banking, insurance, investment, accounting)": "Banking or Financial Services (banking, insurance, investment, accounting)",
    "Business Development (commercial non-retail)": "Business Development (commercial non-retail)",
    "Construction": "Construction",
    "Education Services": "Education Services",
    "Entertainment & Media Services": "Entertainment & Media Services",
    "Engineering/Technical Design Services": "Engineering/Technical Design Services",
    "Executive & Administrative Services": "Executive & Administrative Services",
    "Food and Beverage Services": "Food and Beverage Services",
    "Government": "Government",
    "Legal Professions": "Legal Professions",
    "Life Sciences/Healthcare": "Life Sciences/Healthcare",
    "Management of Companies/Enterprises": "Management of Companies/Enterprises",
    "Manufacturing or Retail Trade": "Manufacturing or Retail Trade",
    "Marketing & Advertising": "Marketing & Advertising",
    "Personal Services (beauty/cleaning/repairs)": "Personal Services (beauty/cleaning/repairs)",
    "Professional Services/Consulting": "Professional Services/Consulting",
    "Real Estate & Rental Licensing": "Real Estate & Rental Licensing",
    "Social Impact": "Social Impact",
    "Sustainability/Green Economy": "Sustainability/Green Economy",
    "Technology or Tech-Enabled": "Technology or Tech-Enabled",
    "Transport/Warehousing/Aviation": "Transport/Warehousing/Aviation"
  },
  es: {
    "Arts & Culture": "Arte y Cultura",
    "Academia (higher ed, postgraduate, academic research)": "Academia (educación superior, posgrado, investigación académica)",
    "Banking or Financial Services (banking, insurance, investment, accounting)": "Servicios Bancarios o Financieros (banca, seguros, inversiones, contabilidad)",
    "Business Development (commercial non-retail)": "Desarrollo de Negocios (comercial no minorista)",
    "Construction": "Construcción",
    "Education Services": "Servicios Educativos",
    "Entertainment & Media Services": "Servicios de Entretenimiento y Medios",
    "Engineering/Technical Design Services": "Servicios de Ingeniería/Diseño Técnico",
    "Executive & Administrative Services": "Servicios Ejecutivos y Administrativos",
    "Food and Beverage Services": "Servicios de Alimentos y Bebidas",
    "Government": "Gobierno",
    "Legal Professions": "Profesiones Jurídicas",
    "Life Sciences/Healthcare": "Ciencias de la Vida/Salud",
    "Management of Companies/Enterprises": "Gestión de Empresas",
    "Manufacturing or Retail Trade": "Manufactura o Comercio Minorista",
    "Marketing & Advertising": "Marketing y Publicidad",
    "Personal Services (beauty/cleaning/repairs)": "Servicios Personales (belleza/limpieza/reparaciones)",
    "Professional Services/Consulting": "Servicios Profesionales/Consultoría",
    "Real Estate & Rental Licensing": "Bienes Raíces y Licencias de Alquiler",
    "Social Impact": "Impacto Social",
    "Sustainability/Green Economy": "Sostenibilidad/Economía Verde",
    "Technology or Tech-Enabled": "Tecnología o Habilitado por Tecnología",
    "Transport/Warehousing/Aviation": "Transporte/Almacenamiento/Aviación"
  }
};

export const BOROUGH_LIST = {
  en: {
    "Manhattan": "Manhattan",
    "Queens": "Queens", 
    "Brooklyn": "Brooklyn",
    "Bronx": "Bronx",
    "Staten Island": "Staten Island",
    "I don't live in NYC": "I don't live in NYC"
  },
  es: {
    "Manhattan": "Manhattan",
    "Queens": "Queens",
    "Brooklyn": "Brooklyn",
    "Bronx": "Bronx",
    "Staten Island": "Staten Island",
    "I don't live in NYC": "No vivo en NYC"
  }
};

export const GENDER_LIST = {
  en: {
    "Female": "Female",
    "Male": "Male",
    "Non-binary/Third Gender": "Non-binary/Third Gender",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "Female": "Femenino",
    "Male": "Masculino",
    "Non-binary/Third Gender": "No binario/Tercer género",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const AGE_LIST = {
  en: {
    "18-24": "18-24",
    "25-34": "25-34",
    "35-44": "35-44",
    "45-54": "45-54",
    "55-64": "55-64",
    "65+": "65+",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "18-24": "18-24",
    "25-34": "25-34",
    "35-44": "35-44",
    "45-54": "45-54",
    "55-64": "55-64",
    "65+": "65+",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const RACE_LIST = {
  en: {
    "Asian": "Asian",
    "American Indian or Alaska Native": "American Indian or Alaska Native",
    "Black or African American": "Black or African American",
    "Native Hawaiian or Pacific Islander": "Native Hawaiian or Pacific Islander",
    "Two or More Races": "Two or More Races",
    "White or Caucasian": "White or Caucasian",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "Asian": "Asiático",
    "American Indian or Alaska Native": "Indio americano o nativo de Alaska",
    "Black or African American": "Negro o afroamericano",
    "Native Hawaiian or Pacific Islander": "Hawaiano o isleño del Pacífico",
    "Two or More Races": "Dos o más razas",
    "White or Caucasian": "Blanco o caucásico",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const ETHNICITY_LIST = {
  en: {
    "Hispanic or Latina(o)": "Hispanic or Latina(o)",
    "Not Hispanic or Latina(o)": "Not Hispanic or Latina(o)",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "Hispanic or Latina(o)": "Hispano o Latina(o)",
    "Not Hispanic or Latina(o)": "No hispano o Latina(o)",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const EDUCATION_LIST = {
en: {
    "High school or equivalent": "High school or equivalent",
    "Some college": "Some college",
    "Associate's Degree": "Associate's Degree",
    "Bachelor's Degree": "Bachelor's Degree",
    "Master's Degree": "Master's Degree",
    "Doctorate": "Doctorate",
    "Professional, Technical or occupational certificate": "Professional, Technical or occupational certificate",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "High school or equivalent": "Bachillerato o equivalente",
    "Some college": "Estudios universitarios incompletos",
    "Associate's Degree": "Título de Asociado",
    "Bachelor's Degree": "Licenciatura",
    "Master's Degree": "Maestría",
    "Doctorate": "Doctorado",
    "Professional, Technical or occupational certificate": "Certificado profesional, técnico u ocupacional",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const INCOME_RANGE_LIST = {
  en: {
    "$0-$68,039": "$0-$68,039",
    "$68,040-$90,719": "$68,040-$90,719",
    "$90,720-$124,739": "$90,720-$124,739",
    "$124,740-$187,109": "$124,740-$187,109",
    "$187,110+": "$187,110+",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "$0-$68,039": "$0-$68,039",
    "$68,040-$90,719": "$68,040-$90,719",
    "$90,720-$124,739": "$90,720-$124,739",
    "$124,740-$187,109": "$124,740-$187,109",
    "$187,110+": "$187,110+",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const OCCUPATION_STATUS_LIST = {
  en: {
    "Student": "Student",
    "Working for an organization": "Working for an organization",
    "Entrepreneur (Business Owner/Self-Employed)": "Entrepreneur (Business Owner/Self-Employed)",
    "Solopreneur (Freelancer/Consultant)": "Solopreneur (Freelancer/Consultant)",
    "Unemployed": "Unemployed",
    "In transition": "In transition",
    "Full-time parenting": "Full-time parenting / Family caregiving",
    "Retired": "Retired",
    "Prefer not to disclose": "Prefer not to disclose"
  },
  es: {
    "Student": "Estudiante",
    "Working for an organization": "Trabajando para una organización",
    "Entrepreneur (Business Owner/Self-Employed)": "Emprendedor (Propietario de negocio/Self-empleado)",
    "Solopreneur (Freelancer/Consultant)": "Solopreneur (Freelance/Consultor)",
    "Unemployed": "Desempleado",
    "In transition": "En transición",
    "Full-time parenting": "Crianza a tiempo completo / Cuidado familiar",
    "Retired": "Jubilado",
    "Prefer not to disclose": "Prefiero no decir"
  }
};

export const PROFESSIONAL_EXPERIENCE_LIST = {
  en: {
    "Intern": "Intern",
    "Entry Level": "Entry Level",
    "Mid-career": "Mid-career",
    "Management": "Management",
    "Senior/Experienced Professional": "Senior/Experienced Professional",
    "Other (please specify)": "Other (please specify)"
  },
  es: {
    "Intern": "Becario",
    "Entry Level": "Nivel de entrada",
    "Mid-career": "Media carrera",
    "Management": "Gestión",
    "Senior/Experienced Professional": "Senior/Profesional experimentado",
    "Other (please specify)": "Otro (por favor especifique)"
  }
};

export const HIGH_GROWTH_INDUSTRY_LIST = {
  en: {
    "Tech": "Tech",
    "Green Economy": "Green Economy",
    "Life Sciences": "Life Sciences"
  },
  es: {
    "Tech": "Tecnología",
    "Green Economy": "Economía Verde",
    "Life Sciences": "Ciencias de la Vida"
  }
};

export const AREA_OF_INTERESTS_LIST = {
  en: {
    "Job Interview Prep": "Job Interview Prep",
    "Changing Industries": "Changing Industries",
    "Personal Branding": "Personal Branding",
    "Networking": "Networking",
    "Moving Into Management": "Moving Into Management",
    "Entrepreneurship": "Entrepreneurship",
    "Jobs of the future": "Jobs of the future",
    "Work-Life Balance": "Work-Life Balance",
    "Negotiation Skills": "Negotiation Skills",
    "Other (please specify)": "Other (please specify)"
  },
  es: {
    "Job Interview Prep": "Preparación para entrevistas de trabajo",
    "Changing Industries": "Cambio de industria",
    "Personal Branding": "Marca personal",
    "Networking": "Networking",
    "Moving Into Management": "Transición a la gestión",
    "Entrepreneurship": "Emprendimiento",
    "Jobs of the future": "Trabajos del futuro",
    "Work-Life Balance": "Equilibrio entre trabajo y vida personal",
    "Negotiation Skills": "Habilidades de negociación",
    "Other (please specify)": "Otro (por favor especifique)"
  }
};

export const HOW_DID_YOU_HEAR_ABOUT_US_LIST = {
  en: {
    "Email": "Email",
    "Instagram": "Instagram",
    "Twitter": "Twitter",
    "LinkedIn": "LinkedIn",
    "Facebook": "Facebook",
    "Eventbrite": "Eventbrite",
    "Word of mouth": "Word of Mouth",
    "Women.nyc website": "Women.nyc website",
    "Internet/Other Social Media": "Internet/Other Social Media"
  },
  es: {
    "Email": "Correo electrónico",
    "Instagram": "Instagram",
    "Twitter": "Twitter",
    "LinkedIn": "LinkedIn",
    "Facebook": "Facebook",
    "Eventbrite": "Eventbrite",
    "Word of mouth": "Boca a boca",
    "Women.nyc website": "Sitio web Women.nyc",
    "Internet/Other Social Media": "Internet/Otros medios sociales"
  }
};

export const BUSINESS_START_PERIOD = {
  en: {
    "Less than 1 year ago": "Less than 1 year ago",
    "1-3 years ago": "1-3 years ago",
    "3-5 years ago": "3-5 years ago",
    "5+ years ago": "5+ years ago",
    "N/A": "N/A"
  },
  es: {
    "Less than 1 year ago": "Menos de 1 año",
    "1-3 years ago": "Hace 1-3 años",
    "3-5 years ago": "Hace 3-5 años",
    "5+ years ago": "Más de 5 años",
    "N/A": "No aplica"
  }
}

export const MWBE = {
  en: {
    "Yes, through New York City.": "Yes, through New York City.",
    "Yes, through New York State.": "Yes, through New York State.",
    "Yes, I have applied for both state and city certification.": "Yes, I have applied for both state and city certification.",
    "No.": "No.",
    "I'm not sure what a MWBE Certification is.": "I'm not sure what a MWBE Certification is.",
    "Other": "Other"
  },
  es: {
    "Yes, through New York City.": "Sí, a través de la ciudad de Nueva York.",
    "Yes, through New York State.": "Sí, a través del estado de Nueva York.",
    "Yes, I have applied for both state and city certification.": "Sí, he solicitado la certificación tanto estatal como municipal.",
    "No.": "No.",
    "I'm not sure what a MWBE Certification is.": "No estoy seguro de qué es una certificación MWBE.",
    "Other": "Otro"
  }
};

export const EMPLOYEES_COUNT = {
  en: {
    "1": "1",
    "2-4": "2-4",
    "5+": "5+",
    "N/A": "N/A"
  },
  es: {
    "1": "1",
    "2-4": "2-4",
    "5+": "5+",
    "N/A": "N/A"
  }
};

export const BUSINESS_STAGE = {
  en: {
    "Pre-Startup (no sales yet)": "Pre-Startup (no sales yet)",
    "Startup (offering goods/services for less than 1 year)": "Startup (offering goods/services for less than 1 year)",
    "Operating (sales for 1+ year)": "Operating (sales for 1+ year)",
    "N/A": "N/A"
  },
  es: {
    "Pre-Startup (no sales yet)": "Preinicio (sin ventas aún)",
    "Startup (offering goods/services for less than 1 year)": "Inicio (ofreciendo bienes/servicios por menos de 1 año)",
    "Operating (sales for 1+ year)": "Operando (ventas por 1+ año)",
    "N/A": "N/A"
  }
};

export const IMPORTANT_GOAL = {
  en: {
    "find a new job.": "find a new job.",
    "grow my network.": "grow my network.",
    "start a new business.": "start a new business.",
    "expand my business.": "expand my business.",
    "advance to leadership.": "advance to leadership.",
    "transition from my current industry to a new industry.": "transition from my current industry to a new industry.",
    "enhance my transferable skills.": "enhance my transferable skills.",
    "enhance my sector-specific skills.": "enhance my sector-specific skills."
  },
  es: {
    "find a new job.": "encontrar un nuevo trabajo.",
    "grow my network.": "ampliar mi red de contactos.",
    "start a new business.": "comenzar un nuevo negocio.",
    "expand my business.": "expandir mi negocio.",
    "advance to leadership.": "ascender a un puesto de liderazgo.",
    "transition from my current industry to a new industry.": "transicionar de mi industria actual a una nueva industria.",
    "enhance my transferable skills.": "mejorar mis habilidades transferibles.",
    "enhance my sector-specific skills.": "mejorar mis habilidades específicas del sector."
  }
};

export const BUSINESS_LOCATION = {
  en: {
    "Rent": "Rent",
    "Own": "Own"
  },
  es: {
    "Rent": "Alquiler",
    "Own": "Propio"
  }
};

export const REVENUE = {
  en: {
    "<$50,000": "<$50,000",
    "$51,000-$100,000": "$51,000-$100,000",
    "$101,000-$150,000": "$101,000-$150,000",
    "$151,000-$500,000": "$151,000-$500,000",
    "$501,000+": "$501,000+",
    "N/A": "N/A"
  },
  es: {
    "<$50,000": "<$50,000",
    "$51,000-$100,000": "$51,000-$100,000",
    "$101,000-$150,000": "$101,000-$150,000",
    "$151,000-$500,000": "$151,000-$500,000",
    "$501,000+": "$501,000+",
    "N/A": "N/A"
  }
};

export const ITEMS_TYPE = {
  en: {
    "Services": "Services",
    "Products": "Products",
    "Both": "Both",
    "Other": "Other",
  },
  es: {
    "Services": "Servicios",
    "Products": "Productos",
    "Both": "Ambos",
    "Other": "Otro",
  }
};

export const THREE_GOALS = {
  en: {
    "make a change to a new industry and/or role": "make a change to a new industry and/or role",
    "learn about job opportunities and understand my focus industry better": "learn about job opportunities and understand my focus industry better",
    "take the next step into leadership and/or management in my field": "take the next step into leadership and/or management in my field",
    "broaden and deepen my strategic network of mentors, sponsors, and/or peers": "broaden and deepen my strategic network of mentors, sponsors, and/or peers",
    "build and strengthen my professional identity and become a thought leader": "build and strengthen my professional identity and become a thought leader",
    "improve my job search skills such as resume building, application techniques, and interview strategies": "improve my job search skills such as resume building, application techniques, and interview strategies",
    "be able to advocate for myself, confidently navigate salary negotiations, and engage in career growth discussions": "be able to advocate for myself, confidently navigate salary negotiations, and engage in career growth discussions",
    "know how to navigate workplace challenges while promoting inclusion and belonging": "know how to navigate workplace challenges while promoting inclusion and belonging",
    "be empowered financially and build generational wealth": "be empowered financially and build generational wealth"
  },
  es: {
    "make a change to a new industry and/or role": "hacer un cambio a una nueva industria y/o rol",
    "learn about job opportunities and understand my focus industry better": "aprender sobre oportunidades laborales y comprender mejor mi industria de enfoque",
    "take the next step into leadership and/or management in my field": "dar el siguiente paso hacia el liderazgo y/o la gestión en mi campo",
    "broaden and deepen my strategic network of mentors, sponsors, and/or peers": "ampliar y profundizar mi red estratégica de mentores, patrocinadores y/o colegas",
    "build and strengthen my professional identity and become a thought leader": "construir y fortalecer mi identidad profesional y convertirme en un líder de opinión",
    "improve my job search skills such as resume building, application techniques, and interview strategies": "mejorar mis habilidades de búsqueda de empleo como la elaboración de currículums, técnicas de aplicación y estrategias de entrevistas",
    "be able to advocate for myself, confidently navigate salary negotiations, and engage in career growth discussions": "ser capaz de abogar por mí mismo, navegar con confianza en negociaciones salariales y participar en discusiones de crecimiento profesional",
    "know how to navigate workplace challenges while promoting inclusion and belonging": "saber cómo navegar los desafíos del lugar de trabajo mientras promuevo la inclusión y pertenencia",
    "be empowered financially and build generational wealth": "empoderarme financieramente y construir riqueza generacional"
  }
};

export const ADVISOR_CATEGORIES = {
  en: {
    "Career Transition": "Career Transition",
    "Industry Insight": "Industry Insight",
    "Leadership Growth": "Leadership Growth",
    "Strategic Networking": "Strategic Networking",
    "Personal Branding": "Personal Branding",
    "Job Search Skills": "Job Search Skills",
    "Negotiation & Advocacy": "Negotiation & Advocacy",
    "Entrepreneurship & Wealth": "Entrepreneurship & Wealth",
    "Workplace Inclusion": "Workplace Inclusion"
  },
  es: {
    "Career Transition": "Transición de carrera",
    "Industry Insight": "Conocimiento de la industria",
    "Leadership Growth": "Crecimiento en liderazgo",
    "Strategic Networking": "Red estratégica",
    "Personal Branding": "Marca personal",
    "Job Search Skills": "Habilidades de búsqueda de empleo",
    "Negotiation & Advocacy": "Negociación y defensa",
    "Entrepreneurship & Wealth": "Emprendimiento y riqueza",
    "Workplace Inclusion": "Inclusión en el lugar de trabajo"
  }
};

export const CURRENT_INDUSTRY_LIST = {
  en: {
    "Tech": "Tech",
    "Life Sciences": "Life Sciences",
    "Green Economy": "Green Economy"
  },
  es: {
    "Tech": "Tecnología",
    "Life Sciences": "Ciencias de la Vida",
    "Green Economy": "Economía Verde"
  }
};